import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';

const ListItem = (props) => {
    const { item } = props;
    const itemLink = '/item1/' + item.index;

    return (
        <div className="col-6 col-lg-3 mb-2 mb-lg-3 px-1">
            <NavLink className="item-card" exact to={itemLink}>
                <div className="bg-color">
                    {item.image.includes('.mp4') ? (
                        <video autoPlay loop muted>
                            <source src={item.image} type="video/mp4" />
                        </video>
                    ) : (
                        <img className="img-fluid" src={item.image} alt={item.name} />
                    )}
                </div>
                <div className="detail-box">
                    <div className="text-capitalize card-name">{item.name}</div>
                    {item.customer ? (
                        <div className="text-capitalize card-name">Owner: {item.customer}</div>
                    ) : ('')}
                </div>
            </NavLink>
        </div>    
    )
}

export default ListItem;